import React from 'react'
import styled, { css } from 'styled-components'

import { Button } from '@sketch/components'
import { ReactComponent as Google } from '@sketch/icons/img-google-17'
import { ButtonWrapper } from '@sketch/components/src/Button/Button.styles'

export const GoogleIcon = styled(Google)`
  width: 17px;
  height: 17px;
`

export const StyledGoogleButton = styled(Button)`
  grid-area: google;
  flex: 1;
  overflow: hidden;
  flex-wrap: wrap;
  padding: 10px 8px;
  color: ${({ theme }) => theme.colors.foreground.secondary.B};

  ${ButtonWrapper} {
    line-height: normal;
  }

  :hover {
    color: ${({ theme }) => theme.colors.foreground.secondary.B};
  }

  /* 
    Hide the icon when loading is true. Usually done by the Button component,
    but since this icon doesn't use currentColor, we need to handle it here.
  */
  ${({ loading }) =>
    loading &&
    css`
      ${GoogleIcon} {
        display: none;
      }
    `}

  @media (prefers-color-scheme: dark) {
    box-shadow: none;
    border: none;
  }
`

export interface ContinueWithGoogleProps {
  onClick: () => void
  loading?: boolean
  disabled?: boolean
  className?: string
}

export const ContinueWithGoogle = ({
  onClick,
  loading = false,
  disabled,
  className,
}: ContinueWithGoogleProps) => {
  return (
    <StyledGoogleButton
      className={className}
      variant="secondary"
      size="40"
      fill
      onClick={onClick}
      loading={loading}
      icon={GoogleIcon}
      disabled={disabled}
    >
      Continue with Google
    </StyledGoogleButton>
  )
}
